import { Col, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteRoleById,
  fetchRoleById,
} from "../../../lib/api/resources/roles";
import { RoleDetailCard } from "./components/RoleDetailCard";
import { RolePermissionsCard } from "./components/RolePermissionsCard";

export const RoleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const roleQuery = useQuery({
    queryKey: ["role", id],
    queryFn: () => fetchRoleById(id),
  });

  const deleteRoleMutation = useMutation({
    mutationFn: () => deleteRoleById(id),
    onSuccess: () => {
      navigate(`/roles`);
      message.success("Rol succesvol verwijderd");
    },
    onError: () =>
      message.error("Er is een fout opgetreden bij het verwijderen van de rol"),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xxl={{ span: 12 }} span={24}>
          <RoleDetailCard
            deleteMutation={deleteRoleMutation}
            role={roleQuery.data}
            isLoading={roleQuery.isFetching}
          />
        </Col>
        <Col xxl={{ span: 12 }} span={24}>
          <RolePermissionsCard
            permissions={roleQuery.data?.permissions}
            isLoading={roleQuery.isFetching}
          />
        </Col>
      </Row>
    </div>
  );
};
